import settings from '../settings';
import Preview from './preview';
import ShareBox from './sharebox';

import FacebookPostCalculator from '../model/facebook-post-calculator';
import LinkedInPostCalculator from '../model/linkedin-post-calculator';
import TwitterPostCalculator from '../model/twitter-post-calculator';
import InstagramPostCalculator from '../model/instagram-post-calculator';

import sweetalert from 'sweetalert';
import 'tooltipsy';
import nunjucks from 'nunjucks';
import preloadNunjucks from '../preload/nunjucks';
var nunjucksEnv = preloadNunjucks();

import moment from 'moment';

export default class Post {
    calculators;

    static renderPost(
        id,
        objPost,
        postInstance,
        bIsBefore,
        showSlowly = false,
        usePreviewClass = false,
        col = 'left',
        isNew = false
    ) {
        let $posts = $('.posts'),
            $list = $posts.find('.posts__list'),
            days_ago = moment().diff(moment(objPost.created), 'days');

        if (7 >= days_ago) {
            objPost.created_ago = moment(objPost.created).fromNow();
        } else {
            objPost.created_ago = moment(objPost.created).format('Do MMM YYYY');
        }

        objPost.hasFacebook =
            $('.user-profile').data('has-facebook') == 1 ? true : false;
        let $post = $(nunjucksEnv.render('html/posts/post.html', objPost));

        if (isNew) {
            $post.addClass('is-new');

            setTimeout(() => $post.removeClass('is-new'), 5000);
        }

        if (showSlowly) $post.addClass('is-hidden');

        let $preview = $post.find('.post__preview'),
            custom_url = objPost.custom_url.url,
            custom_url_title = objPost.custom_url.title,
            custom_url_description = objPost.custom_url.description,
            custom_url_image = objPost.custom_url.image;

        // I don't know what the difference here is but I've kept both for the same circumstances
        if (usePreviewClass) {
            var preview = new Preview();

            if (custom_url == null || custom_url.length == 0) {
                preview.generate_preview(objPost.post, $post, $preview);
            } else {
                preview.create(
                    $preview,
                    custom_url,
                    custom_url_title,
                    custom_url_description,
                    custom_url_image
                );
            }
        } else {
            if (custom_url == null || custom_url.length == 0) {
                postInstance.generatePreview($post);
            } else {
                postInstance.createPreviewForPost(
                    $preview,
                    custom_url,
                    custom_url_title,
                    custom_url_description,
                    custom_url_image
                );
            }
        }

        $post.on('click', '.js-dropdown-trigger', ev => {
            let $me = $(ev.currentTarget),
                $target = $('#' + $me.attr('for'));

            if ($target.attr('checked')) {
                $target.removeAttr('checked');
                $target.siblings('.dropdown').toggleClass('is-active');
            } else {
                $target.attr('checked', 'checked');
                $target.siblings('.dropdown').toggleClass('is-active');
            }
            ev.stopPropagation();
            ev.preventDefault();
        });

        if (bIsBefore) {
            let elementToAppendInto = `.post-list--${col}`;

            $(elementToAppendInto).prepend($post);
        } else {
            let elementToAppendInto = `.post-list--${col}`;
            $(elementToAppendInto).append($post);
        }

        postInstance.setupImageSlider();

        if (showSlowly) $post.slideDown(500, () => $post.removeClass('is-hidden'));

        return $post;
    }

    static renderPosts(posts, postInstance, bIsBefore) {
        const leftColCount = $('.post-list--left .post').length;
        const rightColCount = $('.post-list--right .post').length;

        let col = leftColCount > rightColCount ? 'right' : 'left';

        $.each(posts, (index, element) => {
            this.renderPost(
                index,
                element,
                postInstance,
                bIsBefore,
                false,
                false,
                col
            );
            col = col == 'left' ? 'right' : 'left'; // Alternate the columns
        });

        $('.tooltip').tooltipsy({ offset: [0, -10] });
    }

    constructor() {
        this.sharebox = new ShareBox();

        this.calculators = {
            facebook: new FacebookPostCalculator(),
            linkedin: new LinkedInPostCalculator(),
            twitter: new TwitterPostCalculator(),
            instagram: new InstagramPostCalculator()
        };

        this.click__share = this.click__share.bind(this);
        this.click__share_facebook = this.click__share_facebook.bind(this);
        this.click__comments = this.click__comments.bind(this);
        this.click__reshare = this.click__reshare.bind(this);
        this.click__cancel_edit = this.click__cancel_edit.bind(this);
        this.click__submit_edit = this.click__submit_edit.bind(this);
        this.click__edit = this.click__edit.bind(this);
        this.click__edit_comment = this.click__edit_comment.bind(this);
        this.click__save_comment = this.click__save_comment.bind(this);
        this.click__cancel_edit_comment = this.click__cancel_edit_comment.bind(
            this
        );

        $('.posts')
            .on('click', '.post__share', this.click__share)
            .on('click', '.post__share-facebook', this.click__share_facebook)
            .on('click', '.post__like--add', this.click__like)
            .on(
                'click',
                '.post__like--view, .post__share--view',
                this.click__interations
            )
            .on('click', '.post__meta__item--amped a', this.click__toggle_amp)
            .on(
                'click',
                '.post__edit-box .post__edit-cancel',
                this.click__cancel_edit
            )
            .on(
                'click',
                '.post__edit-box .post__edit-submit',
                this.click__submit_edit
            )
            .on('click', '.post__view-interactions', this.click__view_interactions)
            .on('click', '.trigger--post-comments', this.click__comments)
            .on('click', '.dropdown .post__edit', this.click__edit)
            .on('click', '.dropdown .post__delete', this.click__delete);

        $('.post').each((index, elem) => this.createCustomPreview($(elem)));

        /*
         * These need to be bound here as they're contained in a dropdown which
         * stops the propagation to .posts
         *
         * TODO: Improve the stop propagation selector to prevent so many event binds
         */
        $('.posts .dropdown')
            .on('click', '.post__edit', this.click__edit)
            .on('click', '.post__delete', this.click__delete);

        $('body').on('click', '.btn--share', this.click__reshare);

        this.setupImageSlider();
    }

    click__comments(ev) {
        let $me = $(ev.currentTarget),
            $my_post = $me.parents('.post'),
            id = $my_post.data('id'),
            $list = $my_post.find('.comments__list'),
            tmpl =
            '{% for comment in comments %}{% include "html/posts/comment.html" %}{% endfor %}',
            html,
            request;

        if (!!$me.data('comments')) {
            request = $.ajax({
                headers: settings.api_headers,
                url: '/posts/' + id + '/comments',
                type: 'GET',
                dataType: 'json'
            });

            request.done(data =>
                $list.html(nunjucksEnv.renderString(tmpl, { comments: data.comments }))
            );
        }
    }

    click__delete(ev) {
        ev.preventDefault();

        var $me = $(ev.currentTarget),
            $my_post = $me.parents('.post');

        $me.blur();

        sweetalert({
                title: 'Are you sure?',
                text: 'You will not be able to recover this post. Also all schduled share will also delete.',
                type: 'warning',
                showCancelButton: true,
                closeOnConfirm: false
            },
            isConfirm => {
                if (!isConfirm) return;

                var request = $.ajax({
                    headers: settings.api_headers,
                    url: $me.attr('href'),
                    type: 'DELETE',
                    dataType: 'json'
                });

                request.always((d, ts, jq) => {
                    if (d.status == 410) {
                        sweetAlert({
                            title: 'Success!',
                            text: 'Your post was deleted!',
                            type: 'success'
                        });

                        $my_post.fadeOut(500).slideUp(500, () => $my_post.remove());
                    } else {
                        sweetAlert({
                            title: 'Sorry!',
                            text: 'There was a problem deleting your post',
                            type: 'error'
                        });
                    }
                });
            }
        );
    }

    click__interations(ev) {
        ev.preventDefault();

        var $my_parent = $(ev.currentTarget).parents('.post'),
            $interations = $my_parent.find('.post__interations');

        $interations.toggleClass('is-hidden');
    }

    click__comments(ev) {
        let $me = $(ev.currentTarget),
            $my_post = $me.parents('.post'),
            id = $my_post.data('id'),
            $list = $my_post.find('.comments__list'),
            tmpl =
            '{% for comment in comments %}{% include "html/posts/comment.html" %}{% endfor %}',
            current_user_id = $('.user-profile').data('user-id'),
            html,
            request;

        if (!!$me.data('comments')) {
            request = $.ajax({
                headers: settings.api_headers,
                url: '/posts/' + id + '/comments',
                type: 'GET',
                dataType: 'json'
            });

            request.done(data =>
                $list.html(
                    nunjucksEnv.renderString(tmpl, {
                        comments: data.comments,
                        current_user_id: current_user_id
                    })
                )
            );
        }
    }

    click__like(ev) {
        ev.preventDefault();

        // Build a request based on no existing like
        var $me = $(ev.currentTarget),
            $my_icon = $me.find('i'),
            $my_count = $me.next(),
            added = $me.data('liked') == 1,
            url = $me.attr('href'),
            method = 'POST',
            icon_out = 'icon-not-liked',
            icon_in = 'icon-liked',
            count_adj = 1,
            request;

        // If the user has liked it, change the request
        if (!!added) {
            url = url + '/' + $('.user-profile').data('user-id');
            method = 'DELETE';
            icon_out = 'icon-liked';
            icon_in = 'icon-not-liked';
            count_adj = -1;
        }

        // Run the request
        request = $.ajax({
            headers: settings.api_headers,
            url: url,
            type: method,
            dataType: 'json'
        }).always((d, ts, jq) => {
            // Update the icon by swapping the classes
            $my_icon.removeClass($me.data(icon_out)).addClass($me.data(icon_in));

            // Update the like count
            $my_count.text(parseInt($my_count.text()) + count_adj);

            // Switch the request flag
            $me.data('liked', 1 - $me.data('liked'));
        });
    }

    click__edit(ev) {
        ev.preventDefault();

        var $me = $(ev.currentTarget),
            $my_post = $me.parents('.post'),
            $post__inner = $my_post.find('.post__inner'),
            post = $post__inner.text().trim(),
            html = nunjucksEnv.render('html/posts/edit-box.html', {
                post: post,
                networks: networks
            });

        if (!$my_post.hasClass('is-editing')) {
            $my_post.addClass('is-editing');
            $post__inner.hide().after(html);

            var $counters = $my_post.find('.postbox__counts__count');

            for (var i = $counters.length - 1; i >= 0; i--) {
                var $count = $($counters[i]),
                    calculator = $count.data('calculator'),
                    calc;

                if (!!this.calculators[calculator]) {
                    calc = this.calculators[calculator];

                    calc.$counter = $count;
                    calc.$target = $my_post.find('textarea');

                    $my_post.on('keyup', 'textarea', () => calc.calculate(true));
                    calc.calculate(true);
                }
            }
        }
    }

    click__submit_edit(ev) {
        ev.preventDefault();

        var $me = $(ev.currentTarget),
            $my_post = $me.parents('.post'),
            $post__inner = $my_post.find('.post__inner'),
            $post__edit_box = $my_post.find('.post__edit-box__field'),
            new_post = $post__edit_box.val(),
            request = $.ajax({
                headers: settings.api_headers,
                url: '/posts/' + $my_post.data('id'),
                type: 'POST',
                data: {
                    post: new_post
                }
            });

        request.always((d, ts, jq) => {
            if (jq.status == 200) {
                sweetAlert({
                    title: 'Success!',
                    text: 'Your post was updated successfully!',
                    type: 'success'
                });
                $post__inner.html(new_post);
            } else {
                sweetAlert({
                    title: 'Sorry!',
                    text: 'There was a problem updating your post',
                    type: 'error'
                });
            }
            this.remove_edit_box(ev);
        });
    }

    click__edit_comment(ev) {
        ev.preventDefault();

        var $me = $(ev.currentTarget),
            $comment = $me.parents('.comment'),
            request;

        // Run the request
        request = $.ajax({
            headers: settings.api_headers,
            url: $me.attr('href'),
            type: 'get',
            dataType: 'json'
        }).always((d, ts, jq) => {
            if (jq.status == 200) {
                var html = nunjucksEnv.render('html/posts/edit-comment.html', {
                    comment: d.comment
                });
                $comment.html(html);
            }
        });
    }

    click__cancel_edit_comment(ev) {
        ev.preventDefault();

        let $me = $(ev.currentTarget),
            $comment = $me.parents('.comment'),
            $form = $('form', $comment),
            url = $form.attr('action'),
            request = $.ajax({
                headers: settings.api_headers,
                url: url,
                type: 'GET',
                dataType: 'json'
            });

        request.always((d, ts, jq) => {
            if (jq.status == 200) {
                var html = nunjucksEnv.render('html/posts/comment.html', {
                    comment: d.comment
                });
                $comment.html(html);
            }
        });
    }

    click__save_comment(ev) {
        ev.preventDefault();

        var $me = $(ev.currentTarget),
            $comment = $me.parents('.comment'),
            $form = $('form', $comment),
            url = $form.attr('action'),
            $comment_box = $('textarea', $form),
            comment_box = $comment_box.val(),
            request = $.ajax({
                headers: settings.api_headers,
                url: url,
                type: 'POST',
                data: {
                    comment: comment_box
                }
            });

        //let $c = $comment;

        request.always((d, ts, jq) => {
            if (jq.status == 200) {
                sweetAlert({
                    title: 'Success!',
                    text: 'Your comment was updated successfully!',
                    type: 'success'
                });
                var html = nunjucksEnv.render('html/posts/comment.html', {
                    comment: d
                });
                $comment.html(html);
            } else {
                sweetAlert({
                    title: 'Sorry!',
                    text: 'There was a problem updating your comment',
                    type: 'error'
                });
            }
        });
    }

    click__cancel_edit(ev) {
        ev.preventDefault();

        this.remove_edit_box(ev);
    }

    click__view_interactions(ev) {
        ev.preventDefault();

        let titles = {
            likes: '<i class="fa fa-heart"></i> Colleagues who liked this post',
            shares: '<i class="fa fa-share-alt"></i> Colleagues who shared this post'
        };

        let $me = $(ev.currentTarget).blur(),
            $my_post = $me.parents('.post'),
            post_id = $my_post.data('id'),
            url = $me.attr('href'),
            item_type = $me.data('type'),
            item_title = titles[item_type],
            cols = $me.data('cols'),
            request = $.ajax({
                headers: settings.api_headers,
                url: url,
                type: 'GET',
                dataType: 'json'
            });

        request.done((data, textStatus, jqXHR) => {
            
            let items = data[item_type],
                params = {
                    cancelButtonText: 'Close',
                    customClass: 'sweet-alert--top sweet-alert--scroll sweet-alert--' + item_type,
                    html: true,
                    showCancelButton: true,
                    showConfirmButton: false,
                    text: nunjucksEnv.render('html/ui/user-list.html', {
                        items: items,
                        cols: cols,
                        post_id: post_id,
                        post: data.post
                    }),
                    title: item_title
                },
                callback = this.click__reshare;
            if (!!data[item_type].length) {
                sweetalert(params);
            }
        });
    }

    remove_edit_box(ev) {
        var $me = $(ev.currentTarget),
            $my_post = $me.parents('.post'),
            $post__inner = $my_post.find('.post__inner'),
            $post__edit_box = $my_post.find('.post__edit-box');

        $post__edit_box.remove();
        $post__inner.show();
        $my_post.removeClass('is-editing');
    }

    click__share_facebook(ev) {
        ev.preventDefault();

        var $me = $(ev.currentTarget),
            url = $me.attr('href'),
            request,
            $my_post = $me.parents('.post'),
            post_id = $my_post.data('id');

        request = $.ajax({
            headers: settings.api_headers,
            url: url,
            type: 'POST',
            data: {}
        });

        request.always((d, ts, jq) => {
            if (jq.status == 200) {
                if ('' == d) {
                    sweetAlert({
                        title: 'Sorry!',
                        text: 'You need to connect to Facebook before you can share a post to your Facebook network',
                        type: 'error'
                    });
                } else if (null == d.sharable.clickable_url) {
                    sweetAlert({
                        title: 'Sorry!',
                        text: 'Only posts with a link or media can be shared to Facebook',
                        type: 'error'
                    });
                } else {
                    var fbShareWindow = FB.ui({
                            method: 'share',
                            display: 'popup',
                            href: d.sharable.clickable_url,
                            quote: d.sharable.share
                        },
                        function(response) {
                            var lookupRequest;
                            lookupRequest = $.ajax({
                                headers: settings.api_headers,
                                url: '/posts/' + post_id + '/preshares/' + d.id,
                                type: 'POST',
                                data: {}
                            });

                            lookupRequest.always((d, ts, jq) => {});
                        }
                    );
                }
            } else {
                sweetAlert({
                    title: 'Sorry!',
                    text: 'There was a problem preparing this post to share on Facebook',
                    type: 'error'
                });
            }
        });
    }

    click__share(ev) {
        ev.preventDefault();
        
        var $me = $(ev.currentTarget),
            $my_post = $me.parents('.post'),
            post = $my_post.find('.post__content').text(),
            linkedInPost = $my_post.find('.Linkedin__post__content').text().trim(),
            post_id = $my_post.data('id'),
            video_id = $my_post.data('video-id'),
            $images = $my_post.find('.post__images').find('img');
        // Get number of unaltered shares for this post
        var requestCountries = $.ajax({
            dataType: 'json',
            headers: {
                Accept: 'application/json'
            },
            method: 'GET',
            url: '/posts/' + post_id + '/shares/countries/'
        });
        requestCountries.done(function(response) {
            localStorage.setItem("countries",JSON.stringify(response.countries))
            localStorage.setItem("targetaudienceslists",JSON.stringify(response.targetaudienceslists))
        });
        if ($me.hasClass('btn--disabled')) {
            return false;
        }

        var images = [];
        $.each($images, (i, val) => {
            const image_height = $(val).data('image-height');
            const image_width = $(val).data('image-width');
            const image = {
                socialType: $(val).data("social-type") ,
                image_id: $(val).data('image-id'),
                image_height,
                image_width,
                image_url: $(val).attr('src'),
                image_meets_size_restrictions: this.imageMeetSizeRestrictions(
                    image_height,
                    image_width
                )
            };
            images.push(image);
        });

        var postText = [];
        if($my_post.find(".post_box_text_area").length > 0){
            var allPostText = $my_post.find(".post_box_text_area .social-text");
            $.each(allPostText, function(index, val){
                postText['account-'+$(val).attr("data-id")] = $(val).text();
            })
        }
        var postGeoLocations = [];
        if($my_post.find(".post_box_geo_locations_area").length > 0){
            var postGeoLocations = $my_post.find(".post_box_geo_locations_area .social-geolocations").attr("data-geolocations");
        }
                                    
        this.sharebox.create(post, post_id, false, images, postText,postGeoLocations,video_id, linkedInPost);
    }

    /**
     * Check to see if the image is a size that can be shared to social networks
     * @param {*} height
     * @param {*} width
     */
    imageMeetSizeRestrictions(height, width) {
        if (height >= 8192) {
            return false;
        }

        if (width >= 8192) {
            return false;
        }

        return true;
    }

    click__reshare(ev) {
        ev.preventDefault();

        var $me = $(ev.currentTarget),
            $my_post = $me.parents('.media__body'),
            post = $my_post.find('.post__inner').text(),
            post_id = $my_post.data('post-id'),
            share_id = $my_post.data('share-id'),
            $images = $my_post.find('.post__images').find('img');

        var images = [];
        $.each($images, (i, val) => {
            
            var image = {
                image_id: $(val).data('image-id'),
                image_url: $(val).attr('src'),
                image_meets_size_restrictions: true,
            };
            images.push(image);
        });

        $('.sweet-alert').removeClass('sweet-alert--shares sweet-alert--scroll');

        this.sharebox.reshare = share_id;

        var postText = [];
        if($my_post.find(".post_box_text_area").length > 0){
            var allPostText = $my_post.find(".post_box_text_area .social-text");
            $.each(allPostText, function(index, val){
                postText['account-'+$(val).attr("data-id")] = $(val).text();
            })
        }
        var postGeoLocations = [];
        if($my_post.find(".post_box_geo_locations_area").length > 0){
            var postGeoLocations = $my_post.find(".post_box_geo_locations_area .social-geolocations").attr("data-geolocations");
        }

        var video_id = $my_post.data('video-id');

        var linkedInPost = $my_post.find('.Linkedin__post__content').text().trim();
        
        this.sharebox.create(post.trim(), post_id, false, images, postText,postGeoLocations,video_id, linkedInPost);

        return false;
    }

    click__toggle_amp(ev) {
        ev.preventDefault();

        var $me = $(ev.currentTarget),
            $my_icon = $me.find('i'),
            $my_post = $me.parents('.post'),
            $my_btn = $my_post.find('.post__share'),
            $my_fb_btn = $my_post.find('.post__share-facebook'),
            url = $me.prop('href'),
            request;

        request = $.ajax({
            headers: settings.api_headers,
            url: url,
            type: 'POST',
            dataType: 'json'
        });

        request.always((d, ts, jq) => {
            $my_post.find('.post__meta--stats').toggleClass('is-active');
            $my_post.toggleClass('post--amped');

            $my_icon.toggleClass('icon-amped').toggleClass('icon-non-amped');
            $my_btn.toggleClass('btn--disabled');
            $my_btn.toggleClass('tooltip');
            $my_fb_btn.toggleClass('btn--disabled');
            $my_fb_btn.toggleClass('tooltip');

            if ($my_btn.hasClass('btn--disabled')) {
                $my_btn.attr('title', $my_btn.data('tooltip-text'));
                $my_btn.tooltipsy({ offset: [0, -10] });

                $my_fb_btn.attr('title', $my_btn.data('tooltip-text'));
                $my_fb_btn.tooltipsy({ offset: [0, -10] });
            } else {
                $my_btn.attr('title', '');
                $my_btn.unbind('mouseenter');

                $my_fb_btn.attr('title', '');
                $my_fb_btn.unbind('mouseenter');
            }
        });
    }

    generatePreview($elem) {
        let $preview = $elem.find('.post__preview'),
            preview = new Preview();

        if ($preview.length == 1) {
            preview.generate_preview(
                $elem.find('.post__inner').text(),
                $elem,
                $preview
            );
        }
    }

    image_back_or_next(ev, inc) {
        ev.preventDefault();

        const imagesContainer = $(ev.target)
            .parents('.post__images')
            .find('.post__images__images');
        const images = imagesContainer.find('img');

        if (images.length < 2) {
            return;
        }

        let currentIndex = 0;

        images.each(function() {
            if (!$(this).is(':hidden')) {
                currentIndex = $(this).index();
            }
        });

        let nextIndex = currentIndex + inc;

        if (nextIndex >= images.length) {
            nextIndex = 0;
        }

        images.eq(currentIndex).hide();
        images
            .eq(nextIndex)
            .delay(1)
            .show();
    }

    setupImageSlider() {
        $('.post')
            .on('click', '.post__images__back', ev => {
                this.image_back_or_next(ev, -1);
            })
            .on('click', '.post__images__forward', ev => {
                this.image_back_or_next(ev, 1);
            });
        0;
        $('.post__images__images').each((i, images) => {
            if (1 >= $(images).children('img').length) return;

            $(images)
                .siblings('.post__images__nav')
                .children('.post__images__forward')
                .show();
        });
    }

    createCustomPreview($elem) {
        let $preview = $elem.find('.post__preview'),
            post_id = $elem.data('id'),
            custom_url = $elem.data('custom-url'),
            custom_url_title = $elem.data('custom-url-title'),
            custom_url_description = $elem.data('custom-url-description'),
            custom_url_image = $elem.data('custom-url-image');

        if (custom_url == null || custom_url.length == 0) {
            this.generatePreview($elem);
        } else {
            this.createPreviewForPost(
                $preview,
                custom_url,
                custom_url_title,
                custom_url_description,
                custom_url_image
            );
        }
    }

    createPreviewForPost($preview, url, title, description, image) {
        let preview = new Preview();

        if ($preview.length == 1) {
            preview.create($preview, url, title, description, image);
        }
    }

    init() {
        $('.posts')
            .on('click', '.post__share', this.click__share)
            .on('click', '.post__share-facebook', this.click__share_facebook)
            .on('click', '.post__like--add', this.click__like)
            .on(
                'click',
                '.post__like--view, .post__share--view',
                this.click__interations
            )
            .on('click', '.post__meta__item--amped a', this.click__toggle_amp)
            .on(
                'click',
                '.post__edit-box .post__edit-cancel',
                this.click__cancel_edit
            )
            .on(
                'click',
                '.post__edit-box .post__edit-submit',
                this.click__submit_edit
            )
            .on('click', '.post__view-interactions', this.click__view_interactions)
            .on('click', '.trigger--post-comments', this.click__comments)
            .on('click', '.dropdown .post__edit', this.click__edit)
            .on('click', '.dropdown .post__delete', this.click__delete);

        $('body')
            .on('click', '.edit-comment', this.click__edit_comment)
            .on('click', '.edit-comment-submit', this.click__save_comment)
            .on('click', '.edit-comment-cancel', this.click__cancel_edit_comment);

        $('.post').each((index, thing) => this.createCustomPreview($(thing)));

        /*
         * These need to be bound here as they're contained in a dropdown which
         * stops the propagation to .posts
         *
         * TODO: Improve the stop propagation selector to prevent so many event binds
         */
        $('.posts .dropdown')
            .on('click', '.post__edit', this.click__edit)
            .on('click', '.post__delete', this.click__delete);

        $('body').on('click', '.btn--share', this.click__reshare);
    }
}